export type StaticBrewery = {
  code: string;
  name: string;
  altCode?: string;
};

// As part of #114485, duplicate and blank names from breweries (BVL2, CVL2, HFX, LDN) were removed.
// When we get brewery data from an API someday, we will still need to make sure to exclude these.
export const breweryData: StaticBrewery[] = [
  {
    name: 'Newark',
    code: 'NWK',
    altCode: 'NWK'
  },
  {
    name: 'Fort Collins',
    code: 'FCL',
    altCode: 'FCL'
  },
  {
    name: 'Cartersville',
    code: 'CVL',
    altCode: 'CRTV'
  },
  {
    name: 'Columbus',
    code: 'COL',
    altCode: 'COL'
  },
  {
    name: 'St. Louis',
    code: 'STL',
    altCode: 'STL'
  },
  {
    name: 'London (Labatt)',
    code: 'LON',
    altCode: 'LON'
  },
  {
    name: 'Jacksonville',
    code: 'JAX',
    altCode: 'JKSV'
  },
  {
    name: 'Houston',
    code: 'HTN',
    altCode: 'HTN'
  },
  {
    name: 'Edmonton (Labatt)',
    code: 'EDM',
    altCode: 'EDM'
  },
  {
    name: "St. John's (Labatt)",
    code: 'STJ',
    altCode: 'STJ'
  },
  {
    name: 'Fairfield',
    code: 'FFD',
    altCode: 'FFD'
  },
  {
    name: 'Williamsburg',
    code: 'WMS',
    altCode: 'WMS'
  },
  {
    name: 'Baldwinsville',
    code: 'BVL',
    altCode: 'BLDV'
  },
  {
    name: 'Creston (Labatt)',
    code: 'CRE',
    altCode: 'CRE'
  },
  {
    name: 'Halifax (Labatt)',
    code: 'HAL',
    altCode: 'HAL'
  },
  {
    name: 'Montreal (Labatt)',
    code: 'MTL',
    altCode: 'MTL'
  },
  {
    name: 'Merrimack',
    code: 'MER',
    altCode: 'MERR'
  },
  {
    name: 'Los Angeles',
    code: 'LA',
    altCode: 'LA'
  },
  {
    name: 'Research Pilot Brewery',
    code: 'RPB',
    altCode: 'SCCR'
  }
];
